/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import _debounce from 'lodash/debounce';
import utilityService from './utility.service';
import ConfigDeviceSettings from '../config/device.config';
import { setKeyValueInLocalStorage } from './localstorage/setKeyValueInLocalStorage';
import AppConst from '../constants/app.constant';

const etdService = () => {
  const content = {};
  content.departureTime = null;
  content.resetDepartureTime = () => {
    content.departureTime = null;
  };
  content.saveDepartureTimeToLs = _debounce(() => {
    setKeyValueInLocalStorage(
      AppConst.localstorageConf.lastEdt,
      content.departureTime,
    );
  }, 2000);
  content.setDepartureTime = (value) => {
    content.departureTime = value;
  };
  content.getDepartureTime = (pivot, maxValueOfSlider) => {
    if (content.departureTime) {
      content.saveDepartureTimeToLs();
      return content.departureTime;
    }
    content.departureTime = utilityService.getDepartureTime(
      ConfigDeviceSettings.settings.leftAnchor,
      pivot,
      maxValueOfSlider,
    );
    content.saveDepartureTimeToLs();
    return content.departureTime;
  };
  return content;
};
export default etdService();
